<template>
  <header class="header">
    <div class="header__menu-box">
      <svg class="header__icon u-margin-right-small u-pointer"  @click.stop="showMenu=true">
        <use href="../assets/sprite.svg#icon-bars"></use>
      </svg>
      <!--<h3 class="heading-softname heading-softname--white">exopera 2.0</h3>-->
    </div>
    <div class="header__user-box">
      <h3 class='heading-tertiary heading-tertiary--white'>{{name}} {{firstname}}</h3>
      <img class="header__user-avatar" :src="avatar" alt="">
      <!-- <transition name="fade">
        <Notifications class="header__notification" />
      </transition> -->
      <!-- <LangSwitch /> -->
      <!-- <div class="header__form">
        <form action="#" class="search">
          <input type="text" class="search__input" placeholder="Rechercher">
          <button class="search__button">
            <svg class="search__icon">
              <use href="../assets/sprite.svg#icon-search"></use>
            </svg>
          </button>
        </form>
      </div> -->
      <!-- <img class="header__logo" src="../assets/edisac.png" alt=""> -->
    </div>
    <transition name="fade">
      <component v-show='showMenu' v-hide-on-click.anywhere="showMenu" :is="UserMenu" class='header__user-menu'></component>
    </transition>
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import UserMenu from './UserMenu.vue'
import Notifications from './Notifications'
import LangSwitch from './LangSwitch'

const { mapGetters } = createNamespacedHelpers('user')

export default {
  data: function () {
    return {
      UserMenu,
      showMenu: false
    }
  },
  mounted: function () {
    this.$store.dispatch('user/GET_AVATAR', this.userId)
  },
  components: {
    Notifications,
    LangSwitch
  },
  computed: {
    ...mapGetters({
      avatar: 'getAvatar',
      name: 'getUserName',
      firstname: 'getUserFirstname',
      userId: 'getUserId'
    })
  },
  methods: {
  }
}
</script>
